import { useState, useCallback } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { fetchApiClients } from "../api/apiClientService";
var PAGE_SIZE = 50;
/**
 * Hook for API clients list page with pagination.
 * Simpler than useUserList since API clients don't need CQL search or complex filters.
 */
var useApiClientList = function () {
    var ky = useOkapiKy();
    var _a = useState(""), query = _a[0], setQuery = _a[1];
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(true), filterPaneIsVisible = _c[0], setFilterPaneIsVisible = _c[1];
    var _d = useQuery(["czna-api-clients", pageOffset], function () {
        return fetchApiClients(ky, {
            offset: pageOffset,
            limit: PAGE_SIZE,
        });
    }, {
        keepPreviousData: true,
    }), data = _d.data, isLoading = _d.isLoading, isFetching = _d.isFetching, error = _d.error;
    var handleSearch = useCallback(function (e) {
        e.preventDefault();
        setPageOffset(0);
    }, []);
    var handleClearSearch = useCallback(function () {
        setQuery("");
        setPageOffset(0);
    }, []);
    var handleClearFilters = useCallback(function () {
        setQuery("");
        setPageOffset(0);
    }, []);
    var toggleFilterPane = useCallback(function () {
        setFilterPaneIsVisible(function (prev) { return !prev; });
    }, []);
    var fetchMoreData = useCallback(function (offset) {
        setPageOffset(offset);
    }, []);
    return {
        query: query,
        setQuery: setQuery,
        pageOffset: pageOffset,
        pageSize: PAGE_SIZE,
        filterPaneIsVisible: filterPaneIsVisible,
        toggleFilterPane: toggleFilterPane,
        handleSearch: handleSearch,
        handleClearSearch: handleClearSearch,
        handleClearFilters: handleClearFilters,
        isDefaultFilters: query === "",
        fetchMoreData: fetchMoreData,
        items: (data === null || data === void 0 ? void 0 : data.items) || [],
        totalRecords: (data === null || data === void 0 ? void 0 : data.totalRecords) || 0,
        isLoading: isLoading,
        isFetching: isFetching,
        error: error,
    };
};
export default useApiClientList;
